<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="chapter24">
<h1><a id="page_42"></a><a href="#/003toc#ch24">Creamy Chicken and Wild Rice Soup</a></h1>
<p class="noindent">Comfort food doesn’t get much better than this creamy soup brimming with chunks of moist chicken (or turkey), vegetables, and crunchy wild rice. If you have leftover chicken or turkey, this is a great way to use it. Wild rice is actually a grain and takes quite a while to cook, which is where your slow cooker comes in—you literally set it and forget it.</p>
<p class="noindent">4 tablespoons (½ stick) unsalted butter</p>
<p class="noindent">1 medium onion, finely chopped</p>
<p class="noindent">4 medium carrots, finely chopped</p>
<p class="noindent">4 medium stalks celery with leaves, finely chopped</p>
<p class="noindent">1 pound cremini mushrooms, cut into</p>
<p class="noindent">½-inch slices</p>
<p class="noindent">1 teaspoon dried thyme</p>
<p class="noindent">1 teaspoon dried sage, crushed in the palm of your hand</p>
<p class="noindent">1½ teaspoons salt</p>
<p class="noindent">1 teaspoon freshly ground black pepper</p>
<p class="noindent">8 cups chicken broth</p>
<p class="noindent">3 cups bite-size pieces cooked chicken or turkey, either shredded or diced</p>
<p class="noindent">2 cups wild rice, rinsed several times with cold water</p>
<p class="noindent">1 cup heavy cream</p>
<p class="noindent">¼ cup finely chopped fresh Italian parsley (optional)</p>
<p class="noindent">heat the butter in a large skillet over medium-high heat.</p>
<p class="noindent">add the onion, carrots, and celery and sauté until the vegetables are softened, about 3 minutes. Add the mushrooms, thyme, and sage to the pan and season with the salt and pepper.</p>
<p class="noindent">transfer the contents of the skillet to the insert of a 5- to</p>
<p class="noindent">7-quart slow cooker. Stir in the chicken broth, chicken, and wild rice.</p>
<p class="noindent">cover the slow cooker and cook on low for 4 to 5 hours, until the wild rice is tender and the soup is thickened.</p>
<p class="noindent">stir in the cream and parsley (if using), turn the cooker to warm, and serve the soup.</p>
<p class="noindent">serves 6–8</p>
<hr/>
<p class="sidebar_head"><img alt="image 1" class="inline" src="images/image-01.jpg"/> slow-cooker savvy</p>
<p class="noindent">Vegetarian wild rice soup? Omit the chicken or turkey and substitute vegetable or mushroom broth for the chicken broth.</p>
<p class="sidebar">
</p><h3 class="left"><span class="uppercase">STARTING THE POT</span></h3>
<p class="noindent">Many cuisines have a basic mixture of vegetables that starts a variety of dishes. In France, a <i>mirepoix</i> is a mixture of onion, celery, and carrot; New Orleans has its trinity—onion, bell pepper, and celery; Italy has <i>battuto</i>—onion, garlic, celery, carrot, and tomato; and Spain has its <i>sofrito</i>, which is generally olive oil, garlic, onions, and tomatoes.</p>
<p class="sidebar">
</p></div>
<p class="breakhere"></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 030-chapter24.vue?807500de